"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConquestTypes = {
    notConverted: 1,
    converted: 2,
    creditConvert: 3
};
